import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import InsuranceCompanies from "../components/InsuranceCompanies";
import Header from "../01-Services/Header";
import ServiceItem from "../01-Services/ServiceItem";
import AwardsCertifications from "../01-Services/AwardsCertifications";
import { Helmet } from "react-helmet-async";
import { Box } from "@mui/material";
import ServiceDetail from "../01-Services/ServiceDetail";
import StrategicAlliances from "../01-Services/StrategicAlliances";
import {
  dataFarmacia,
  dataHeader,
  dataHospitalizacion,
  dataUrgencias,
  torreMedica,
} from "../data/servicesData";

const Services = () => {
  const [pending, setPending] = useState(null);
  const [visible, setVisible] = useState(true);

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const name = query.get("name");

  const [selected, setSelected] = useState(
    dataHeader.find((f) => f.name === name) || dataHeader[0],
  );

  const handleClick = (item) => {
    if (item.name === selected.name) return;

    setVisible(false);
    setPending(item);
  };

  useEffect(() => {
    if (!visible && pending) {
      const timeout = setTimeout(() => {
        setSelected(pending);
        setVisible(true);
        setPending(null);
      }, 150);

      return () => clearTimeout(timeout);
    }
  }, [visible, pending]);

  return (
    <>
      <Helmet>
        <title>Servicios médicos | Centro Médico MEDAM</title>
        <meta
          name="description"
          content="Conoce los servicios médicos del Centro Médico MEDAM en Texcoco: urgencias 24 horas, hospitalización, laboratorio clínico, farmacia, atención especializada y servicios a domicilio."
        />
        <meta
          name="keywords"
          content="servicios médicos MEDAM, hospitalización Texcoco, urgencias 24 horas, laboratorio clínico, farmacia, especialistas médicos, servicio a domicilio, Centro Médico MEDAM"
        />
        <meta name="author" content="Centro Médico MEDAM" />
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_MX" />
        <meta property="og:site_name" content="Centro Médico MEDAM" />
        <meta
          property="og:title"
          content="Servicios médicos | Centro Médico MEDAM"
        />
        <meta
          property="og:description"
          content="Atención médica integral con especialistas, urgencias, hospitalización, laboratorio, farmacia y servicios de salud en Texcoco."
        />
        <meta
          property="og:url"
          content="https://centromedicomedam.com/servicios"
        />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_Torre_Medica_del_centro-medico_MEDAM.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Servicios médicos | Centro Médico MEDAM"
        />
        <meta
          name="twitter:description"
          content="Urgencias, hospitalización, laboratorio, farmacia y atención especializada en el Centro Médico MEDAM."
        />
        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/backgroundImage_Torre_Medica_del_centro-medico_MEDAM.png"
        />
        <link rel="canonical" href="https://centromedicomedam.com/servicios" />
      </Helmet>
      <Header
        fulter={dataHeader}
        selected={selected}
        handleClick={handleClick}
        visible={visible}
      />
      <Box sx={design.Box}>
        {selected.name === "Torre medica" && <ServiceItem data={torreMedica} />}
        {selected.name === "Hospitalización" && (
          <ServiceItem data={dataHospitalizacion} />
        )}
        {selected.name === "Urgencias" && (
          <ServiceDetail data={dataUrgencias} />
        )}
        {selected.name === "Laboratorio Clínico" && <StrategicAlliances />}
        {selected.name === "Farmacia" && <ServiceDetail data={dataFarmacia} />}
        <InsuranceCompanies />
        <AwardsCertifications />
      </Box>
    </>
  );
};

export default Services;
const design = {
  Box: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
};
